<template>
  <v-app>
    <v-content>
       <keep-alive>
            <!--router-view组件是一个 functional 组件，渲染路径匹配到的视图组件-->
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
         <keep-alive>
          <!--不需要缓存组件-->
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </keep-alive>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      //
    };
  }
};
</script>
